<template>
    <v-card>
        <v-img height="80" src="@/assets/images/fondo1.png">
            <v-row>
                <v-row class="pa-4" align="center" justify="center">
                    <v-col class="text-center">
                        <h1 class="headline black--text">Seguimiento Alumno</h1>
                    </v-col>
                </v-row>
            </v-row>
        </v-img>
        <v-tabs>
            <v-tab><v-icon left>search</v-icon>Buscar</v-tab>
            <v-tab><v-icon left>pie_chart</v-icon>Por Secciones</v-tab>
            <v-tab-item>
                <CMatConsejeriaSearch/>
            </v-tab-item>
            <v-tab-item>
                <CMatConsejeriaBySeccion/>
            </v-tab-item>
        </v-tabs>
    </v-card>    
</template>

<script>
import CMatConsejeriaSearch from '@/components/Academico/MatConsejeriaSearch.vue'
import CMatConsejeriaBySeccion from '@/components/Academico/MatConsejeriaBySeccion.vue'

export default {
    name: 'MatConsejeria',
    components: {CMatConsejeriaSearch, CMatConsejeriaBySeccion},
}
</script>